module.exports = __webpack_public_path__ + "static/media/logo-alfredosmondino.92e6d716.svg";